// pages/Home.js
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAnimation from "../components/useAnimation";
import PageEnterOverlay from "../components/PageEnterOverlay";
import HeroSection from "../components/sections/HeroSection";
import AboutSection from "../components/sections/AboutSection";
import ExperienceSection from "../components/sections/ExperienceSection";
import SkillsSection from "../components/sections/SkillsSection";
import EducationSection from "../components/sections/EducationSection";
import { preloadRoute } from "../utils/preloadAssets";

const Home = () => {
  const location = useLocation();
  const { isAnimating, animationMode } = useAnimation(
    1200,
    location.state?.fromTransition,
  );

  useEffect(() => {
    preloadRoute("/");
  }, []);

  return (
    <div>
      <PageEnterOverlay
        show={isAnimating}
        mode={animationMode}
        direction="down"
        bgClass="bg-darkBrown"
      />
      <HeroSection />
      <AboutSection />
      <ExperienceSection />
      <SkillsSection />
      <EducationSection />
    </div>
  );
};

export default Home;
